/** Situações do cliente */
export interface ClienteCadastro {
    id: number;
    nome: string;
    color: string;
    badge: string;
}

export const clienteCadastroProspect: ClienteCadastro = {
    id: 1,
    nome: 'Prospect',
    color: '#237dd8',
    badge: 'badge badge-cliente-cadastro-prospect'
};

export const clienteCadastroCliente: ClienteCadastro = {
    id: 2,
    nome: 'Cliente',
    color: '#20b75d',
    badge: 'badge badge-cliente-cadastro-cliente'
};
export const clienteCadastroBaixado: ClienteCadastro = {
    id: 4,
    nome: 'Baixado',
    color: '#f55e59',
    badge: 'badge badge-cliente-cadastro-baixado'
};
export const clienteCadastroOutros: ClienteCadastro = {
    id: 99,
    nome: 'Outros',
    color: '#565656',
    badge: 'badge badge-cliente-cadastro-outros'
};

export const clienteCadastros: ClienteCadastro[] = [
    clienteCadastroProspect,
    clienteCadastroCliente,
    clienteCadastroBaixado,
    clienteCadastroOutros
];

/** Verifica se o cadastro do cliente é igual a Prospect */
export function isClienteCadastroProspect(cadastro: number): boolean {
    return cadastro === clienteCadastroProspect.id;
}

/** Verifica se o cadastro do cliente é igual a Cliente */
export function isClienteCadastroCliente(cadastro: number): boolean {
    return cadastro === clienteCadastroCliente.id;
}

/** Verifica se o cadastro do cliente é igual a Baixado */
export function isClienteCadastroBaixado(cadastro: number): boolean {
    return cadastro === clienteCadastroBaixado.id;
}

/** Verifica se o cadastro do cliente é igual a Outros */
export function isClienteCadastroOutros(cadastro: number): boolean {
    return cadastro === clienteCadastroOutros.id;
}
